export {
  TableSections,
  TableSectionsProps,
  TableSectionsProp,
} from './TableSections';
